const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^[+()\d\s.-]+$/;

const required = (value, label) =>
  value.trim() ? "" : `${label} is required`;

export const validatePurchaseDetails = (customer, billingAddress) => {
  const errors = {
    "customer.fullName":
      required(customer.fullName, "Full name") ||
      (customer.fullName.trim().length < 2
        ? "Full name must contain at least 2 characters"
        : ""),
    "customer.email": required(customer.email, "Email")
      ? "Email is required"
      : EMAIL_PATTERN.test(customer.email.trim())
        ? ""
        : "A valid email address is required",
    "customer.phone": required(customer.phone, "Phone number")
      ? "Phone number is required"
      : customer.phone.trim().length < 7 ||
          customer.phone.trim().length > 30 ||
          !PHONE_PATTERN.test(customer.phone.trim())
        ? "Enter a valid phone number"
        : "",
    "billingAddress.country": required(
      billingAddress.country,
      "Country",
    )
      ? "Country is required"
      : /^[A-Za-z]{2}$/.test(billingAddress.country.trim())
        ? ""
        : "Use a two-letter country code",
    "billingAddress.state": required(billingAddress.state, "State"),
    "billingAddress.city": required(billingAddress.city, "City"),
    "billingAddress.zip": required(billingAddress.zip, "ZIP code"),
    "billingAddress.line1": required(
      billingAddress.line1,
      "Address line 1",
    ),
  };

  return Object.fromEntries(
    Object.entries(errors).filter(([, message]) => message),
  );
};
